   $('.help-acc-heading').click(function(e) {
    	e.preventDefault();
      let $this = $(this);
      if ($this.hasClass('show-acc')) {
          $this.removeClass('show-acc');
          $this.next().slideUp(350);
      } else {
          $this.parent().parent().find('.help-acc-heading').removeClass('show-acc');
          $this.parent().parent().find('.help-acc-content').slideUp(350);
          $this.toggleClass('show-acc');
         $this.next().slideToggle(350);
      }
  });